import { c as _c } from "react/compiler-runtime";
import { VercelTriangle } from "./VercelTriangle";
export type PreviewProvider = "vercel" | "mintlify";

/** Hosts match PreviewBuildStateService's Mintlify check. */
const MINTLIFY_HOST = /(^|\.)mintlify\.(site|app)$/;

/** `https://docs-branch.mintlify.site/page` → "mintlify"; anything else → "vercel". */
export function previewProvider(url: string | null | undefined): PreviewProvider {
  if (!url) return "vercel";
  try {
    return MINTLIFY_HOST.test(new URL(url).hostname) ? "mintlify" : "vercel";
  } catch {
    return "vercel";
  }
}
function MintlifyMark(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M19.6602 3.31265e-06C19.8478 0.000160743 19.9998 0.152468 20 0.340141V7.3691C20.0013 8.33731 19.8111 9.29627 19.4406 10.1907C19.0701 11.0853 18.5264 11.8981 17.8409 12.5817L17.7892 12.6312C17.6396 12.7786 17.4834 12.9183 17.3224 13.0517C17.4832 12.919 17.6395 12.7803 17.7892 12.6337L12.6319 17.791L12.5802 17.843C11.3267 19.0948 9.66485 19.854 7.898 19.981C6.13109 20.1081 4.3775 19.5947 2.95785 18.535L8.16684 13.3274L8.22111 13.2738C8.80915 13.7174 9.46149 14.0687 10.1556 14.3151C11.4577 14.7783 12.8644 14.8663 14.2141 14.569C14.4387 14.5195 14.66 14.4587 14.8778 14.3888C14.7524 14.4288 14.6257 14.4662 14.4979 14.4994C14.8715 13.0656 14.8064 11.5527 14.3109 10.1564C13.8247 8.79022 12.9451 7.59844 11.7828 6.73155C10.4896 5.76103 8.91189 5.24554 7.2952 5.2646C6.69083 5.27158 6.08946 5.35108 5.50432 5.50253C5.35292 6.08347 5.27169 6.6852 5.2672 7.29537C5.24599 8.91216 5.76094 10.4903 6.73163 11.7833L6.67736 11.8353L1.46837 17.0454C0.406167 15.6261 -0.10809 13.8708 0.0189726 12.1025C0.146099 10.3343 0.906341 8.67125 2.16051 7.41852C2.17737 7.40083 2.19559 7.38424 2.21478 7.3691H2.21228L7.3695 2.2109H7.37201L7.42377 2.15979C8.10697 1.47453 8.91861 0.931022 9.81244 0.560477C10.7062 0.189969 11.6644 -0.000917091 12.6319 3.31265e-06H19.6602Z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg viewBox="0 0 20 20" fill="currentColor" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function PreviewProviderIcon(t0) {
  const $ = _c(3);
  const {
    provider,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== provider) {
    t1 = provider === "mintlify" ? <MintlifyMark className={className} /> : <VercelTriangle className={className} />;
    $[0] = className;
    $[1] = provider;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}